// components/TokenExpiryWarning.js
import React from "react";
import { Modal, Button, ProgressBar, Alert } from "react-bootstrap";
import { useTokenExpiry } from "../hooks/useTokenExpiry";

const TokenExpiryWarning = () => {
  const { 
    showWarning, 
    timeLeft, 
    refreshToken, 
    handleLogout, 
    isRefreshing, 
    error,
    setError
  } = useTokenExpiry();

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const handleRefresh = async () => {
    setError('');
    await refreshToken();
  };

  if (!showWarning) return null;

  return (
    <Modal show={showWarning} centered backdrop="static" keyboard={false} className="token-expiry-modal">
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className="text-warning">
          <i className="bi bi-clock-history me-2"></i>
          Session bientôt expirée
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <div className="mb-4">
          <i className="bi bi-hourglass-split text-warning" style={{ fontSize: '4rem' }}></i>
        </div>
        
        <h5 className="mb-3">Votre session expire dans</h5>
        
        <div className="display-4 fw-bold text-warning mb-3">
          {formatTime(timeLeft)}
        </div>
        
        <ProgressBar 
          now={(timeLeft / 300) * 100} 
          variant="warning"
          className="mb-3"
          style={{ height: '8px' }}
        />
        
        <p className="text-muted small">
          Votre session va expirer dans moins de 5 minutes. 
          Cliquez sur "Prolonger la session" pour rester connecté.
        </p>

        {error && (
          <Alert variant="danger" className="mt-3">
            <i className="bi bi-exclamation-triangle me-2"></i>
            {error}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center">
        <Button 
          variant="outline-secondary" 
          onClick={handleLogout}
          disabled={isRefreshing}
        >
          <i className="bi bi-box-arrow-right me-2"></i>
          Se déconnecter
        </Button>
        <Button 
          variant="warning" 
          onClick={handleRefresh}
          disabled={isRefreshing}
        >
          {isRefreshing ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Rafraîchissement...
            </>
          ) : (
            <>
              <i className="bi bi-arrow-repeat me-2"></i>
              Prolonger la session
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TokenExpiryWarning;